import CreateContext from './dashboard/CreateContext';
import CreateCustomer from './dashboard/CreateCustomer';
import Dashboard from './Dashboard';
import Discount from './dashboard/Discount';
import DiscountCondition from './dashboard/DiscountCondition';
import NftBurning from './dashboard/NftBurning';
import NftCreation from './dashboard/NftCreation';
import NftReqBurn from './dashboard/NftReqBurn';
import NftSelling from './dashboard/NftSelling';
import PrivateRoute from './PrivateRoute';
import ResetPassword from './auth/ResetPassword';
import RestorePassword from './auth/RestorePassword';
import TransferIngredient from './dashboard/TransferIngredient';
import { Login } from './auth/Login';
import { Routes, Route } from 'react-router-dom';
import NftThawing from "./dashboard/NftThawing";
import BoxTrace from "./BoxTrace";
import DiscountTrace from "./DiscountTrace";

export const paths = {
    root: '/',
    restorePassword: 'restore-password',
    resetPassword: 'reset-password',
    dashboard: 'dashboard',
    addContext: 'add-context',
    addCustomer: 'add-customer',
    nftCreation: 'nft-creation',
    transferIngredient: 'transfer-ingredient',
    nftDiscount: 'nft-discount',
    discountCondition: 'discount-condition',
    nftSelling: 'nft-selling',
    nftReqBurn: 'nft-req-burn',
    nftThawing: 'nft-thawing',
    nftBurning: 'nft-burning',
    boxtrace: 'boxchainscan',
    discounttrace: 'chainscan',
};

export const AppRouter = () => (
    <Routes>
        <Route path={paths.discounttrace} element={<DiscountTrace/>}/>
        <Route path={paths.boxtrace} element={<BoxTrace/>}/>
        <Route path={paths.root} element={<Login/>}/>
        <Route path={paths.restorePassword} element={<RestorePassword/>}/>
        <Route path={paths.resetPassword} element={<ResetPassword/>}/>
        <Route element={<PrivateRoute/>}>
            <Route path={paths.dashboard} element={<Dashboard/>}>
                <Route path={paths.addContext} element={<CreateContext/>}/>
                <Route path={paths.addCustomer} element={<CreateCustomer/>}/>
                <Route path={paths.nftCreation} element={<NftCreation/>}/>
                <Route path={paths.nftDiscount} element={<Discount/>}/>
                <Route path={paths.discountCondition} element={<DiscountCondition/>}/>
                <Route path={paths.transferIngredient} element={<TransferIngredient/>}/>
                <Route path={paths.nftSelling} element={<NftSelling/>}/>
                <Route path={paths.nftReqBurn} element={<NftReqBurn/>}/>
                <Route path={paths.nftThawing} element={<NftThawing/>}/>
                <Route path={paths.nftBurning} element={<NftBurning/>}/>
            </Route>
        </Route>
    </Routes>
);
